<template>
  <div class="footer-main">
    <div>{{ $t('总金额:') }}&nbsp;{{ invitationPrice }}&nbsp;{{ $t('元') }}</div>
    <div @click="_click()" class="button">{{ text }}</div>
  </div>
</template>
<script>
export default {
  props: {
    invitationPrice: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },
  methods: {
    _click() {
      if (this.disabled) return
      this.$emit('click')
    },
  },
}
</script>
<style scoped>
.footer-main {
  height: 60px;
  padding: 0 16px;
  display: flex;
  background: #fff;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #000000;
}
.button {
  width: 150px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 4px;
  color: #ffffff;
  background: rgba(230, 55, 64, 1);
}
</style>
